import * as React from 'react';
import { cn } from 'lib/utils';
import { EllipsisIcon } from 'lucide-react';
import { ServiceOrderProduct } from 'contracts/service-order-products';
import { Box } from 'components/ui/Box';
import { Skeleton } from 'components/ui/skeleton';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from 'components/ui/table';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from 'components/ui/dropdown-menu';
import { Formatter } from 'utils';

type Props = React.HTMLAttributes<HTMLDivElement> & {
  serviceOrderProducts: ServiceOrderProduct[];
  onUpdateWorkedQuantity?: (product: ServiceOrderProduct) => void;
  showActionsDropdown?: boolean;
}

export const ServiceOrderProductsTable = ({ serviceOrderProducts, onUpdateWorkedQuantity, showActionsDropdown, className }: Props) => {
  return (
    <div className={cn('', className)}>
      <Box>
        <Table>
          <TableHeader>
            <TableRow className="font-GilroySemibold text-sm">
              <TableHead className="w-[100px]">Planta</TableHead>
              <TableHead>Planta Destino</TableHead>
              <TableHead>SLOC</TableHead>
              <TableHead>Lote</TableHead>
              <TableHead>Vencimento</TableHead>
              <TableHead>Previsão de recebimento</TableHead>
              <TableHead>Quantidade</TableHead>
              <TableHead>Qtd. prod. liberado</TableHead>
              <TableHead>Valor</TableHead>
              <TableHead>Motivo</TableHead>
              <TableHead>Produto</TableHead>
              {showActionsDropdown && <TableHead></TableHead>}
            </TableRow>
          </TableHeader>
          <TableBody>
            {serviceOrderProducts.map((item) => (
              <TableRow key={item.id} className="font-sans text-xs">
                <TableCell>{item.plant}</TableCell>
                <TableCell>{item.destinationPlant ?? '---'}</TableCell>
                <TableCell>{item.storageLocation}</TableCell>
                <TableCell>{item.batch}</TableCell>
                <TableCell>{Formatter.date(item.shelfLifeExpirationDate)}</TableCell>
                <TableCell>{Formatter.date(item.deliveryForecastDate)}</TableCell>
                <TableCell>{Formatter.decimal(item.blockedStock)} {item.unit}</TableCell>
                <TableCell>{Formatter.decimal(item.workedQuantity)} {item.unit}</TableCell>
                <TableCell>{Formatter.currency(item.totalValue, 'USD')}</TableCell>
                <TableCell>{item.productReasonType?.description || '---'}</TableCell>
                <TableCell>{item.materialDescription} ({item.material})</TableCell>
                {showActionsDropdown && <TableCell className="w-8">
                  <ActionsDropdown
                    serviceOrderProduct={item}
                    onUpdateWorkedQuantity={onUpdateWorkedQuantity}
                  />
                </TableCell>}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </div>
  );
};

type ActionsDropdownProps = Pick<Props, 'onUpdateWorkedQuantity'> & {
  serviceOrderProduct: ServiceOrderProduct;
}

const ActionsDropdown = ({ onUpdateWorkedQuantity, serviceOrderProduct }: ActionsDropdownProps) => {
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger>
        <EllipsisIcon className={'text-gray-600'} />
      </DropdownMenuTrigger>
      <DropdownMenuContent align={'end'}>
        <DropdownMenuItem onClick={(event) => {
          onUpdateWorkedQuantity?.(serviceOrderProduct);
          event.stopPropagation();
        }}>
          Alterar qtd. prod. liberado
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

ServiceOrderProductsTable.Skeleton = function () {
  return (
    <Box className="w-full">
      <Table>
        <TableHeader>
          <TableRow className="font-GilroySemibold text-sm">
            <TableHead className="w-[100px]">Planta</TableHead>
            <TableHead>SLOC</TableHead>
            <TableHead>Lote</TableHead>
            <TableHead>Vencimento</TableHead>
            <TableHead>Quantidade</TableHead>
            <TableHead>Qtd. prod. liberado</TableHead>
            <TableHead>Valor</TableHead>
            <TableHead>Motivo</TableHead>
            <TableHead>Produto</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {[...Array(3)].map((_, index) => (
            <TableRow key={index}>
              <TableCell><Skeleton className="h-4 w-full" /></TableCell>
              <TableCell><Skeleton className="h-4 w-full" /></TableCell>
              <TableCell><Skeleton className="h-4 w-full" /></TableCell>
              <TableCell><Skeleton className="h-4 w-full" /></TableCell>
              <TableCell><Skeleton className="h-4 w-full" /></TableCell>
              <TableCell><Skeleton className="h-4 w-full" /></TableCell>
              <TableCell><Skeleton className="h-4 w-full" /></TableCell>
              <TableCell><Skeleton className="h-4 w-full" /></TableCell>
              <TableCell><Skeleton className="h-4 w-full" /></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};